<template>
  <nav class="navigator">
    <p
      class="navigator__caption"
      v-html="isTouchDevice() ? 'Swipe to discover' : 'Scroll to be a time traveler'"
    />
    <span class="navigator__progress-cont">
      <span class="navigator__progress"></span>
    </span>
    <ul class="navigator__container">
      <li
        v-for="(year, i) in years"
        :key="i"
        @click="$eventHub.$emit('scrollTo', i + 1)"
        @mouseenter="cursorToDot()"
        @mouseleave="cursorToClose()"
        class="navigator__dot"
      >
        <span class="dot__year">{{ year }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { isTouchDevice } from '@/scripts/utils';


export default {
  name: 'AppNavigator',

  data() {
    return {
      years: ['1997', '1998', '2001', '2004', '2010', '2011', '2018', 'Buy Now'],
      navigator: null,
      isTouchDevice,
    };
  },

  methods: {
    cursorToDot() {
      this.$eventHub.$emit('cursorToDot');
    },

    cursorToClose() {
      if (!this.$store.state.scrollIsLocked) {
        this.$eventHub.$emit('cursorToClose');
      } else {
        this.$eventHub.$emit('cursorToScroll');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navigator {
  position: fixed;
  bottom: 40px;
  width: 6.25vw;
  height: 3px;
  left: 50%;

  border-radius: 3px;
  background-color: rgba($color-black, 0.1);

  z-index: z-index(header);

  @include mq(ipadL) {
    bottom: 76px;
    width: 6.25vw;
    height: 5px;
  }

  &__caption {
    position: absolute;
    top: -55px;
    margin: 0;
    padding: 0;

    white-space: nowrap;
    color: $color-primary;

    @include mq(ipadL) {
      top: -40px;

      color: $color-white;
      font-size: font-size(xs);
    }

    @include mq($until: ipadL) {
      width: 100%;
      text-align: center;
    }
  }

  &__progress-cont {
    border-radius: 3px;
    overflow: hidden;
  }

  &__progress-cont,
  &__progress,
  &__container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    border-radius: 3px;
  }

  &__container {
    top: -30px;
  }

  .navigator__progress {
    background-color: $color-primary;

    transform-origin: 0% 50%;
  }

  .navigator__container {
    width: calc(100% + 40px);
    margin: 0 0 0 -20px;
    padding: 0;
    list-style: none;
  }

  .navigator__dot {
    position: relative;
    padding: 20px;
    height: 25px;

    cursor: none;

    &:last-child {
      color: $color-gray;
    }

    @include mq($and: $is-not-touch-device) {
      &:hover {
        &::before {
          background-color: $color-white;
        }

        .dot__year {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      }
    }

    &::before {
      content: '';

      display: inline-block;
      position: relative;
      width: 3px;
      height: 3px;
      margin: 0;
      padding: 0;
      border-radius: 5px;

      background-color: $color-primary;
      transition: transform 0.3s $inOutCirc;


      @include mq(ipadL) {
        width: 5px;
        height: 5px;
      }
    }
  }

  .navigator__container,
  .navigator__dot {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dot__year {
    position: absolute;
    top: -20px;
    left: 50%;

    font-size: 12px;
    white-space: nowrap;

    opacity: 0;
    transform: translateX(-50%) translateY(15px);
    transition: transform 0.3s $inOutCirc,
      opacity 0.3s $inOutCirc;
  }
}
</style>
